import React from 'react';
import Button from '@mui/material/Button';
import { COLOR } from '@src/styles/color';
import { variantMapping } from './variants';
import Typography from '../Typography';

const CommonButton = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false,
  onClick,
  startIcon,
  endIcon,
  type = 'button',
  customStyle,
  textProps,
  ...rest
}) => (
  <Button
    sx={{
      ...variantMapping[variant],
      ...customStyle,
      '&.Mui-disabled': {
        background: rest?.bgrDisabled || COLOR.gray[32],
      },
    }}
    variant={variant}
    color={color}
    size={size}
    disabled={disabled}
    onClick={onClick}
    startIcon={startIcon}
    endIcon={endIcon}
    type={type}
    {...rest}
  >
    {textProps ? (
      <Typography
        component={textProps.component}
        variant={textProps.variantText}
        color={textProps.color}
        className={textProps?.className}
      >
        {children}
      </Typography>
    ) : (
      children
    )}
  </Button>
);

export default CommonButton;
